import React, { useEffect, useState} from 'react';

import { NavLink } from "react-router-dom" ;

//import axios from 'axios';
import * as Config from '../Config.js'; 

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import {List, ListItem} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import TopAppBar from './TopAppBar' ;

import { ArrowCircleUp, Login, Image, PermMedia, Group, Logout, Delete } from '@mui/icons-material';

import { useTranslation } from "react-i18next";

function HomeScreen()  {
    const { t } = useTranslation();
    const [user, setUser] = useState(null) ;
    
     useEffect(() => {
        console.log('EFFECT HOME SCREEN') ;
        console.log(`Api Url = ${Config.apiUrl}`) ;
        console.log(`Test env ${process.env.REACT_APP_TEST}`) ;
        fetch(Config.apiUrl  + '/site/get-user', {
            credentials: 'include',
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                console.log(res.user) ;
                setUser(res.user) ;
            } else {
                setUser(null) ; 
            }
        })
        .catch((e) => {
            setUser(null) ;
            console.log(e.message) ;
        }) 
    // the next line prevents the useEffect excessive warning
    // eslint-disable-next-line react-hooks/exhaustive-deps        
    },[]) ;
    
   
    const unregister = () => {
        // delete user on server
        fetch(Config.apiUrl  + '/site/unregister', {
          credentials: 'include',
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                logout() ;
            } else {
                alert(res.error) ;
            }
        })
        .catch( (e) => {
            console.log(e.message) ;
        }) 
    }
    
    const logout = () => {
        fetch(Config.apiUrl  + '/site/logout', {
              credentials: 'include',
            })
            .then(response => response.json())
            .then( (res) => {
                setUser(null) ;
            })
            .catch((e) => {
                setUser(null) ;
            })
    }
    
  
    const actionUnregister = () => {
        if(window.confirm("Your account and all associated data will be removed")) {
            unregister()
        }
    }    
    
    return (
        <Container maxWidth="sm">
        <TopAppBar 
            title={t("Home") + ' ' + (user != null ? user.name : "")} 
            returnLink={false}
            />
        <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { m: 1, width: '25ch' },
              color: 'primary.main',
            }}
            noValidate
            autoComplete="off"
        >
        <List>
            { user == null  &&
                <ListItem sx={{color: 'primary.main'}} component={NavLink} to="/register">
                    <ListItemButton>
                        <ListItemIcon sx={{color: 'primary.main'}}>
                            <ArrowCircleUp/>
                        </ListItemIcon>
                        <ListItemText primary={t("Register")} />
                    </ListItemButton>
                </ListItem>
            }        
            { user == null  &&
                <ListItem  sx={{color: 'primary.main'}} component={NavLink} to="/login">
                    <ListItemButton>
                        <ListItemIcon sx={{color: 'primary.main'}} >
                            <Login/>
                        </ListItemIcon>
                        <ListItemText primary={t("Login")} />
                    </ListItemButton>
                </ListItem>
            }
            { user != null  &&
                <ListItem sx={{color: 'primary.main'}} component={NavLink} to="/my_events/mine">
                    <ListItemButton>
                        <ListItemIcon sx={{color: 'primary.main'}}>
                            <Image/>
                        </ListItemIcon>
                        <ListItemText  primary={t("My Events")} />
                    </ListItemButton>
                </ListItem>
            }
            { user != null  &&
                <ListItem sx={{color: 'primary.main'}} component={NavLink} to="/my_events/friends">
                    <ListItemButton>
                        <ListItemIcon sx={{color: 'primary.main'}}>
                            <PermMedia/>
                        </ListItemIcon>
                        <ListItemText primary={t("Friend Events")} />
                    </ListItemButton>
                </ListItem>
            }
            { user != null  &&
                <ListItem sx={{color: 'primary.main'}} component={NavLink} to="/my_friends">
                    <ListItemButton>
                        <ListItemIcon sx={{color: 'primary.main'}}>
                            <Group/>
                        </ListItemIcon>
                        <ListItemText primary={t("My Friends")} />
                    </ListItemButton>
                </ListItem>
            }

            { user != null  &&
                <ListItem sx={{color: 'primary.main'}} onClick={() => logout()}>
                    <ListItemButton>
                        <ListItemIcon sx={{color: 'primary.main'}}>
                            <Logout/>
                        </ListItemIcon>
                        <ListItemText primary={t("Log Out")} />
                    </ListItemButton>
                </ListItem>
            }
            { user != null  &&
                <ListItem sx={{color: 'error.main'}} onClick={() => actionUnregister()}>
                    <ListItemButton>
                        <ListItemIcon sx={{color: 'error.main'}}>
                            <Delete/>
                        </ListItemIcon>
                        <ListItemText primary={t("Delete Account")} />
                    </ListItemButton>
                </ListItem>
            }
        </List>    
        </Box> 
        
        </Container>
    );
} 

export default HomeScreen ;
